import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { CTA, CtaPanel, Layout } from "../components/Chrome";
import { EASE, Marquee, MaskedLines, Reveal } from "../components/Motion";
import { marqueeItems } from "../data";

export default function Home() {
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: heroRef, offset: ["start start", "end start"] });
  const moonY = useTransform(scrollYProgress, [0, 1], [0, 180]);
  const badgeOpacity = useTransform(scrollYProgress, [0, 0.6], [1, 0]);
  return (
    <Layout>
      <section className="hero" ref={heroRef} data-testid="home-hero">
        <motion.div className="moon-glow" style={{ y: moonY }} aria-hidden="true">
          <span className="orbit orbit-one" />
          <span className="orbit orbit-two" />
        </motion.div>
        <div className="hero-inner">
          <motion.span
            className="eyebrow eyebrow-gold"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15, ease: EASE }}
          >
            Influencer Marketing & Creator Partnerships
          </motion.span>
          <MaskedLines
            as="h1"
            className="hero-title"
            delay={0.25}
            lines={[<>Connecting Brands</>, <>With The <em>Right</em></>, <>Creators.</>]}
          />
          <motion.div
            className="hero-sub"
            initial={{ opacity: 0, y: 26 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.8, ease: EASE }}
          >
            <p>Moon Media is an influencer marketing and creator partnerships agency helping brands discover, collaborate with and activate creators who genuinely connect with their target audience.</p>
            <div className="hero-actions">
              <CTA variant="gold">Start a Campaign</CTA>
              <CTA to="/creators" variant="night">Explore Our Creator Network</CTA>
            </div>
          </motion.div>
          <motion.div
            className="hero-bottom"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.2 }}
          >
            <span>The right creators for the right campaign.</span>
            <span className="scroll-hint" data-testid="scroll-hint">Scroll to explore</span>
          </motion.div>
        </div>
        <motion.div className="hero-badge" style={{ opacity: badgeOpacity }} aria-hidden="true">
          <svg viewBox="0 0 120 120">
            <defs>
              <path id="badge-circle" d="M60,60 m-46,0 a46,46 0 1,1 92,0 a46,46 0 1,1 -92,0" />
            </defs>
            <text><textPath href="#badge-circle">The right creators · for the right campaign ·</textPath></text>
          </svg>
          <span className="badge-dot" />
        </motion.div>
      </section>

      <Marquee items={marqueeItems} />

      <section className="band statement">
        <Reveal as="span" className="eyebrow" y={14}>01 / The Moon Media approach</Reveal>
        <div>
          <MaskedLines as="h2" inView lines={[<>Influence,</>, <><em>With Intention.</em></>]} />
          <Reveal as="p" delay={0.3}>Creator marketing is more than numbers. We look at audience relevance, content quality, language, geography, engagement and campaign objectives to identify creators who make sense for your brand.</Reveal>
        </div>
      </section>

      <section className="home-grid section-pad">
        <div>
          <Reveal as="span" className="eyebrow" y={14}>02 / Built around fit</Reveal>
          <MaskedLines as="h2" inView lines={[<>Every brief</>, <>has a <em>different</em></>, <>answer.</>]} />
        </div>
        <div className="home-grid-copy">
          <Reveal as="p">We bring a considered lens to creator discovery — matching the nuance of your campaign with people, communities and content that feel right.</Reveal>
          <Reveal delay={0.2}><CTA to="/about" variant="light">Discover Moon Media</CTA></Reveal>
        </div>
      </section>

      <CtaPanel lines={[<>Let’s make your next</>, <><em>campaign count.</em></>]} />
    </Layout>
  );
}
